import styled, { css } from 'styled-components';
import { BORDER_BOX } from 'common';

export default {
  Carousel: styled.div`
    display: flex;
    flex-direction: column;
    ${({ $rtl }) => $rtl && css`
      direction: rtl;
    `}
  `,
  CarouselContent: styled.div`
    ${BORDER_BOX}
    min-height: 12.5rem;
    padding: 0.875rem 0 1.25rem 0;
    flex-grow: 1;
    overflow: hidden;
    position: relative;
  `,
  CarouselIndicator: styled.div`
    ${BORDER_BOX}
    height: 1.25rem;
    width: 1.25rem;
    border-radius: 100%;
    background: content-box;
    cursor: pointer;
    outline: none;
    margin: 0 0.25rem;
    padding: 0.125rem;
    border: 0.125rem solid transparent;
    ${({ selected, $theme }) => css`background-color: ${selected ? $theme.active.background : $theme.background};`}
    &:hover {
      ${({ $theme }) => css`background-color: ${$theme.hover.background};`}
    }
    &:focus {
      ${({ $theme }) => css`border-color: ${$theme.focus.border};`}
    }
    &:active {
      ${({ $theme }) => css`background-color: ${$theme.pressed.background};`}
    }
  `,
  CarouselIndicatorContainer: styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
  `,
};